var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    {
      staticClass: "p-3 mt-2 shadow-sm bg-white email-row",
      nativeOn: {
        dblclick: function($event) {
          return _vm.viewEmail($event)
        }
      }
    },
    [
      _c(
        "vs-col",
        {
          attrs: {
            "vs-lg": "1",
            "vs-type": "flex",
            "vs-align": "center",
            "vs-justify": "center"
          }
        },
        [
          _c("vs-avatar", {
            attrs: {
              icon: _vm.item.hasAttachments ? "attach_file" : "email",
              color: _vm.item.hasAttachments ? "primary" : "gray",
              size: "40px"
            }
          })
        ],
        1
      ),
      _c(
        "vs-col",
        { attrs: { "vs-lg": "7" } },
        [
          _c(
            "vs-row",
            [
              _c("vs-col", { attrs: { "vs-lg": "6" } }, [
                _c(
                  "div",
                  {
                    staticClass: "font-weight-bold text-truncate",
                    attrs: { title: _vm.senderDisplay }
                  },
                  [
                    _c("feather-icon", {
                      staticClass: "mr-1",
                      attrs: { icon: "UserIcon", size: "14" }
                    }),
                    _vm._v(" " + _vm._s(_vm.senderDisplay) + " ")
                  ],
                  1
                )
              ]),
              _c("vs-col", { attrs: { "vs-lg": "6" } }, [
                _c(
                  "div",
                  {
                    staticClass: "text-muted text-truncate",
                    attrs: { title: _vm.recipientDisplay }
                  },
                  [
                    _c("feather-icon", {
                      staticClass: "mr-1",
                      attrs: { icon: "ArrowRightIcon", size: "14" }
                    }),
                    _vm._v(" " + _vm._s(_vm.recipientDisplay) + " ")
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c(
            "vs-row",
            [
              _c("vs-col", { attrs: { "vs-lg": "12" } }, [
                _c(
                  "div",
                  {
                    staticClass: "text-truncate mt-1",
                    attrs: { title: _vm.item.subject }
                  },
                  [_c("strong", [_vm._v(_vm._s(_vm.item.subject))])]
                )
              ])
            ],
            1
          ),
          _vm.item.hasAttachments && _vm.item.attachments.length > 0
            ? _c(
                "vs-row",
                [
                  _c("vs-col", { attrs: { "vs-lg": "12" } }, [
                    _c(
                      "div",
                      { staticClass: "mt-1" },
                      [
                        _vm._l(_vm.visibleAttachments, function(attachment) {
                          return _c(
                            "vs-chip",
                            {
                              key: attachment.id,
                              staticClass: "mr-1",
                              attrs: { color: "rgba(var(--vs-primary), 0.1)" }
                            },
                            [
                              _c("vs-avatar", {
                                attrs: { icon: "attach_file", size: "small" }
                              }),
                              _vm._v(" " + _vm._s(attachment.name) + " ")
                            ],
                            1
                          )
                        }),
                        _vm.item.attachments.length > 3
                          ? _c("span", { staticClass: "text-muted small" }, [
                              _vm._v(
                                " +" +
                                  _vm._s(_vm.item.attachments.length - 3) +
                                  " más "
                              )
                            ])
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "vs-col",
        { attrs: { "vs-lg": "2", "vs-type": "flex", "vs-align": "center" } },
        [
          _c(
            "div",
            { staticClass: "text-muted small" },
            [
              _c("feather-icon", {
                staticClass: "mr-1",
                attrs: { icon: "ClockIcon", size: "14" }
              }),
              _vm._v(
                " " +
                  _vm._s(_vm._f("dateFormatDateTime")(_vm.localTimestamp)) +
                  " "
              )
            ],
            1
          )
        ]
      ),
      _c(
        "vs-col",
        {
          attrs: {
            "vs-lg": "2",
            "vs-type": "flex",
            "vs-align": "center",
            "vs-justify": "center"
          }
        },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Ver correo",
                  expression: "'Ver correo'"
                }
              ],
              staticClass: "btn-icon rounded-circle",
              attrs: { variant: "outline-primary", size: "sm" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.viewEmail($event)
                }
              }
            },
            [_c("feather-icon", { attrs: { icon: "EyeIcon" } })],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }